import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=b743743c&scoped=true&"
import script from "./Results.js?vue&type=script&lang=js&"
export * from "./Results.js?vue&type=script&lang=js&"
import style0 from "./Results.scss?vue&type=style&index=0&id=b743743c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b743743c",
  null
  
)

export default component.exports